import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React from 'react'

const StyledPagination = styled('div')(({ theme }) => ({
  display: 'none',
  margin: '8px 0',
  height: '10px',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },

  '& .slide-pagination-bullet': {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    appearance: 'none',
    border: 'none',
    display: 'inline-block',
    padding: '0',
    margin: '0 2px',
    cursor: 'pointer',
    backgroundColor: 'rgba(0, 83, 160, 0.12)',
    '&.arrow': {
      width: 0,
      height: 0,
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderLeft: '8px solid rgba(0, 83, 160, 0.12)',
      borderRadius: 0,
      background: 'none',
    },
  },

  '& .slide-pagination-bullet-active': {
    backgroundColor: '#0053A0',
    width: '10px',
    height: '10px',
    '&.arrow': {
      borderLeftColor: 'rgb(0, 83, 160) !important',
    },
  },

  '& .sr-only': {
    border: '0 !important',
    clip: 'rect(1px, 1px, 1px, 1px) !important',
    clipPath: 'inset(50%) !important',
    height: '1px !important',
    margin: '-1px !important',
    overflow: 'hidden !important',
    padding: '0 !important',
    position: 'absolute !important',
    width: '1px !important',
    whiteSpace: 'nowrap !important',
  },
}))

const NavBullets = ({ mainSwiper, slides, currentSlideIndex }) => {
  if (!mainSwiper) return null
  const slideTo = index => {
    mainSwiper.slideTo(index)
  }

  const slideNext = () => mainSwiper.slideNext()

  const handleMiddleClick = () => {
    switch (currentSlideIndex) {
      case 0:
      case 1:
      case slides.length - 1:
      case slides.length - 2:
      case slides.length - 3:
        slideTo(2)
        break
      default:
        slideNext()
        break
    }
  }
  return (
    <StyledPagination>
      {slides.length > 5 ? (
        <>
          <button
            type="button"
            className={`slide-pagination-bullet${currentSlideIndex === 0 ? ' slide-pagination-bullet-active' : ''}${
              slides[0].type === 'htmlvideo' ? ' arrow' : ''
            }`}
            onClick={() => slideTo(0)}
          >
            <span className="sr-only">Slide to 1</span>
          </button>
          <button
            type="button"
            className={`slide-pagination-bullet${currentSlideIndex === 1 ? ' slide-pagination-bullet-active' : ''}${
              slides[1].type === 'htmlvideo' ? ' arrow' : ''
            }`}
            onClick={() => slideTo(1)}
          >
            <span className="sr-only">Slide to 2</span>
          </button>
          <button
            type="button"
            className={`slide-pagination-bullet${
              currentSlideIndex > 1 && currentSlideIndex < slides.length - 2 ? ' slide-pagination-bullet-active' : ''
            }${slides[2].type === 'htmlvideo' ? ' arrow' : ''}`}
            onClick={handleMiddleClick}
          >
            <span className="sr-only">{`Slide to ${currentSlideIndex === slides.length - 3 ? '3' : 'next'}`}</span>
          </button>
          <button
            type="button"
            className={`slide-pagination-bullet${
              currentSlideIndex === slides.length - 2 ? ' slide-pagination-bullet-active' : ''
            }`}
            onClick={() => slideTo(slides.length - 2)}
          >
            <span className="sr-only">{`Slide to ${slides.length - 1}`}</span>
          </button>
          <button
            type="button"
            className={`slide-pagination-bullet${
              currentSlideIndex === slides.length - 1 ? ' slide-pagination-bullet-active' : ''
            }`}
            onClick={() => slideTo(slides.length - 1)}
          >
            <span className="sr-only">{`Slide to ${slides.length}`}</span>
          </button>
        </>
      ) : (
        slides.map((_slide, index) => (
          <button
            type="button"
            key={`slide-pagination-${Math.random().toString()}`}
            className={`slide-pagination-bullet${currentSlideIndex === index ? ' slide-pagination-bullet-active' : ''}${
              _slide.type === 'htmlvideo' ? ' arrow' : ''
            }`}
            onClick={() => slideTo(index)}
          >
            <span className="sr-only">{`Slide to ${index + 1}`}</span>
          </button>
        ))
      )}
    </StyledPagination>
  )
}

export default NavBullets

NavBullets.propTypes = {
  mainSwiper: PropTypes.object,
  slides: PropTypes.array.isRequired,
  currentSlideIndex: PropTypes.number.isRequired,
}
